"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFormat = void 0;
const dateTimeFormat_1 = require("./dateTimeFormat");
/**
 * formatuje datę do formatu yyyy-MM-dd
 * @param dt data typu Date
 */
function dateFormat(dt) {
    if (process.env.NODE_ENV !== 'production') {
        console.log('fdata: ' + dt);
    }
    return dateTimeFormat_1.formatDateFunction['yyyy-MM-dd'](dt);
}
exports.dateFormat = dateFormat;
//# sourceMappingURL=dateFormat.js.map